import styled from "styled-components";
import { bp } from "theme";

export const JobCardWrapper = styled.div`
	padding: 12px;
	border: 1px solid #e8e7ea;
	box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
	background: #ffffff;
	border-radius: 8px;
	// margin: 6px 12px;
	cursor: pointer;
	// max-width: 512px;
	${bp.md} {
		height: 100%;
		margin: 0px;
	}
`;

export const JobCardContainer = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`;

export const CardHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const HeaderLeftSection = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 12px;
`;

export const ImageWrapper = styled.div`
	position: relative;
	width: 32px;
	height: 32px;
	border-radius: 4px;
	margin-right: 8px;
`;

export const ImgComp = styled.img`
	position: relative;
	width: 100%;
	height: 100%;
	object-fit: contain;
`;

export const ImageWrapper2 = styled.div`
	position: relative;
	width: 16px;
	height: 16px;
	margin-right: 2px;
`;

export const JobTitle = styled.a`
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: #190a28;
`;

export const JobCompany = styled.div`
	font-size: 12px;
	line-height: 16px;
	color: #8c8594;
`;

export const ContentContainer = styled.div`
	font-size: 14px;
	line-height: 20px;
	color: #8c8594;
	> div:not(:last-child) {
		margin-bottom: 4px;
	}
`;

export const DisplayFlexCenter = styled.div`
	display: flex;
	align-items: center;
`;

export const BottomContainer = styled(ContentContainer)`
	color: #190a28;
	display: flex;
	> div:not(:last-child) {
		margin: 0px;
		margin-right: 12px;
	}
`;

export const InterviewLineContainer = styled(ContentContainer)`
	color: #a42700;
	background-color: #fff2eb;
	display: flex;
	padding: 4px 8px;
	> div:not(:last-child) {
		margin: 0px;
		margin-right: 12px;
	}
`;

export const TagContainerWrapper = styled.div`
	margin: 12px 0px;
	display: flex;
	flex-wrap: nowrap;
	overflow-x: auto;
	&::-webkit-scrollbar {
		width: 0;
		height: 0;
	}

	&::-webkit-scrollbar-thumb {
		background-color: transparent;
	}
`;

export const TagContainer = styled.span`
	flex-shrink: 0;
	background: #f2f2f3;
	border-radius: 2px;
	height: 24px;
	padding: 0px 4px;
	display: flex;
	align-items: center;
	font-size: 14px;
	line-height: 20px;
	color: #827485;
	margin-right: 4px;
`;

export const ExternalJobLabel = styled.div`
	display: flex;
	align-items: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	color: #8c8594;
	margin: 12px 0 0 0;
	padding: 4px;

	border-radius: 4px;
	background: linear-gradient(90deg, #f4f2f6 0%, rgba(244, 242, 246, 0) 100%);

	p {
		margin: 0 0 0 4px;
	}
`;
